// v136.29 - the earlier email, copied in below a reply.
//
// Head Office, 23 Oct 2026: replies from stores arrived with none of the earlier messages underneath, so the
// chain looked as if it had vanished. Forward has always quoted the original (v126.14); Reply and Reply all
// quoted nothing, and the reply only carried the threading headers, which keep Outlook's conversation
// grouping but show no history in the email itself. Now a reply carries the earlier email the way Outlook
// does, and as that email already carries its own history, the whole chain travels on.
//
// Pure: no DOM, no network. The caller (src/chat/index.js composeEmail) puts the result below an empty line
// for the store to type above.

// The longest quote a reply carries. Kept well inside the send limit (MAX_SEND_BODY in
// src/worker/store-email.js, 50,000) so the store's own words always fit above it.
export const REPLY_QUOTE_MAX = 40000;
export const REPLY_QUOTE_CUT_NOTE = '[Earlier messages shortened to fit]';

// "Thu 23 Oct 2026, 09:15" in Dubai time; the raw value if it cannot be read.
export function quoteWhen(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return String(iso);
  try {
    return d.toLocaleString('en-GB', {
      timeZone: 'Asia/Dubai', weekday: 'short', day: 'numeric', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false,
    });
  } catch (e) { return d.toISOString().slice(0, 16).replace('T', ' '); }
}

// The block to put below a reply, or '' when there is nothing to quote (the body has not arrived yet, or
// the email had no text). `m` is the opened email (shapeEmail in src/worker/store-email.js).
export function buildReplyQuote(m, maxLen) {
  if (!m || m.body_state === 'pending') return '';
  const body = String(m.text_body || '').replace(/\r\n/g, '\n').replace(/\s+$/, '');
  if (!body.trim()) return '';
  const cap = maxLen || REPLY_QUOTE_MAX;
  const to = Array.isArray(m.to) ? m.to.filter(Boolean).join(', ') : '';
  let head = '---------- Earlier message ----------\n'
    + 'From: ' + (m.from || m.from_addr || '(unknown)') + '\n'
    + 'Sent: ' + quoteWhen(m.received_at) + '\n'
    + (to ? 'To: ' + to + '\n' : '')
    + 'Subject: ' + (String(m.subject || '').trim() || '(no subject)') + '\n\n';
  // The newest messages are at the TOP of a chain, so a long one keeps its beginning and loses its end.
  let text = body;
  if (head.length + text.length > cap) {
    text = text.slice(0, Math.max(0, cap - head.length - REPLY_QUOTE_CUT_NOTE.length - 2)).replace(/\s+$/, '') + '\n\n' + REPLY_QUOTE_CUT_NOTE;
  }
  return '\n\n' + head + text;
}
